/*
 * 照片标签类型定义
 */
export interface PhotoTag {
  id: string
  name: string
  scope: 'team' | 'personal'
  tagType?: 'ai'
  color?: string
  order?: number
  createdAt?: number
  useCount?: number
  // 是否已停用。停用标签在打标场景 (TagPickerPopover / manage/batch) 不出现,
  // 但在管理弹窗 (PhotoTagManageModal) 保留显示,允许重新启用或删除 (前提 useCount=0)。
  disabled?: boolean
}

export interface PhotoTagGroup {
  id: string
  name: string
  scope: 'team'
  tagIds: string[]
  order?: number
}

/**
 * 照片标签「问题反馈」的问题类型选项。
 * 直接用中文值提交给后端（后端原样落库 + 钉钉展示），前端无需再做 code→文案映射。
 */
export const PHOTO_LABEL_FEEDBACK_TYPES = [
  '功能不好用',
  '有 bug / 报错',
  '标签不够用 / 想要更多',
  '操作不顺手 / 建议',
  '其他'
] as const

export type PhotoLabelFeedbackType = (typeof PHOTO_LABEL_FEEDBACK_TYPES)[number]
